import { Instance, applySnapshot, flow, getParent, types } from 'mobx-state-tree';

import {
	deleteAcademicLevel,
	getAcademicLevel,
	updateAcademicLevel,
} from '@common/api/academicLevels';

const AcademicLevel = types
	.model('AcademicLevel', {
		id: types.identifierNumber,
		name: types.optional(types.string, ''),
		programCount: types.optional(types.number, 0),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views(() => ({}))
	.actions((self) => ({
		fetch: flow(function* () {
			self.loading = true;
			try {
				const result = yield getAcademicLevel(self.id);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
		remove: flow(function* () {
			self.loading = true;
			try {
				yield deleteAcademicLevel(self.id);
				const parent: any = getParent(self, 2);
				parent.removeItem(self);
			} catch (e) {
				self.loading = false;
			}
		}),
		save: flow(function* (data: any) {
			self.loading = true;
			try {
				const result = yield updateAcademicLevel(self.id, data);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default AcademicLevel;

export interface IAcademicLevelModel extends Instance<typeof AcademicLevel> {}
